export default __webpack_public_path__ + "static/media/api-icon.ecd08d9d.svg";